import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ADMIN } from "../constants/testIds";

function formatDetail(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#090D16] flex items-center justify-center p-6 relative overflow-hidden" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(circle at 30% 20%, rgba(245,158,11,0.1), transparent 60%), radial-gradient(circle at 80% 80%, rgba(16,185,129,0.08), transparent 60%)" }}
      />
      <div
        data-testid={ADMIN.loginCard}
        className="relative z-10 w-full max-w-sm bg-[#111827]/90 backdrop-blur-xl border border-slate-800 rounded-2xl p-8 shadow-[0_8px_32px_rgba(0,0,0,0.5)]"
      >
        <h1 className="text-2xl font-bold text-slate-50 mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
          ZZZsleep Garden
        </h1>
        <p className="text-sm text-slate-500 mb-6">Admin command center</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <Input
            data-testid={ADMIN.emailInput}
            type="email"
            placeholder="Admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-[#1E293B] border-slate-700 text-slate-100"
          />
          <Input
            data-testid={ADMIN.passwordInput}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="bg-[#1E293B] border-slate-700 text-slate-100"
          />
          {error && <p data-testid={ADMIN.loginError} className="text-sm text-red-400">{error}</p>}
          <Button
            data-testid={ADMIN.loginSubmit}
            type="submit"
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 rounded-full transition-colors duration-300 font-semibold"
          >
            {loading ? "Signing in..." : "Enter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
